export default "__VITE_ASSET__BJ9G74qf__"